import PropTypes from 'prop-types'
import React from 'react'

// Components
import Icon from 'app/views/components/Icon'


const TipsForGettingOutput = () => (
  <div
    className="uk-margin-top"
    style={{
      background: '#333',
      border: '1px solid #444',
      borderLeft: '3px solid #1e87f0',
      color: '#EEE',
      padding: 15,
    }}
  >
    <div style={{ float: 'left', width: 50 }}>
      <Icon
        name="information"
        ratio={1.2}
      />
    </div>
    <div style={{ float: 'left', width: 'calc(100% - 50px)' }}>
      <h4 className="uk-light" style={{ marginBottom: 10 }}>Tips for getting output</h4>

      <p className="uk-margin-remove">
        <a
          href="https://help.hackedu.com/en/articles/4789265-tips-for-getting-output"
          target="_blank"
          style={{ textDecoration: "underline" }}
        >
          See examples for printing output in each language
        </a>
      </p>
      <p>
        To see compilation errors, syntax errors, and output (e.g. print
        statements), you must interact with the application to trigger the
        output.
      </p>
      <p>
        For printing debug statements, do not use the browser console for
        output. This tab will act like your development terminal/console.
      </p>


    </div>
    <div style={{ clear: 'both' }} />
  </div>
)


export default TipsForGettingOutput
